import React from 'react';
import { IProps as IBlockProps } from './SearchResultsBlock.interface';
import { SearchResultsBlock } from './SearchResultsBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IBlockInputProps {
    autoCompleteApiUrl?: string;
    autoCompleteRedirectUrl?: string;
    autoCompletePlaceholder?: string;
    autoCompleteButtonText?: string;
    searchApiUrl: string;
    qryParamSearchQuery: string;
    qryParamCategories: string;
    qryParamCurrentPage: string;
    qryParamPageSize: string;
    qryParamSortBy: string;
    pageSize: number;
    searchQuery?: string | null;
    categoryIDs?: string[] | string | null; // Assuming categoryIDs can be a single string, an array of strings, or null
    currentPage?: number;
    noResultsMessage: string;
    errorMessage?: string | null;
    searchTitle: string;
    mobileSearchTitle: string;
    searchButtonText: string;
    sortByOptions: {
        title: string;
        items: {
            text: string;
            value: string;
            selected: boolean;
        }
    };
    [key: string]: any; // Allow passthrough of other props, including BlockWrapper props
}

// TODO -- update this

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { searchApiUrl, ...rest } = input;

    // Perform any necessary transformations from input props to component props here.
    // For the initial setup, we assume a direct pass-through or minimal mapping.
    return {
        apiUrl: searchApiUrl,
        // searchTerm: cmsSearchTerm || input.searchTerm, // Example mapping
        ...rest, // Spread the rest of the input props
    }; // Ensure the return type matches
};

export const BlockTranslation: React.FC<IBlockInputProps> = (
    inputProps,
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={SearchResultsBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;
